import logo from './logo.svg';
import './App.css';
import { react, useState, useRef, useEffect } from 'react';
import Navbar from './Components/Navbar';
import NavbarNoUser from './Components/NavbarNoUser';
import { Route, Routes } from 'react-router';
import Pickups from './Components/Pickups';
import MyAccount from './Components/MyAccount';
import Training from './Components/Training';
import Marketing from './Components/Marketing'
import ContactUs from './Components/ContactUs';
import Store from './Components/Store';
import Admin from './Components/Admin/Admin';
import BrandLookup from './Components/BrandLookup/BrandLookup';
import RecyclerLogin from './Components/RecyclerLogin';
import { PayPalScriptProvider, PayPalButtons } from "@paypal/react-paypal-js";
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import LoadingIndicator from './Components/LoadingIndicator'
import { SnackbarProvider } from 'notistack';

import TokenService from './services/TokenService.jsx';

import { createTheme, ThemeProvider } from '@mui/material/styles';

const { palette } = createTheme();
const { augmentColor } = palette;
const createColor = (mainColor) => augmentColor({ color: { main: mainColor } });
const theme = createTheme({
    palette: {
        primary: createColor('#383838'),
        secondary: createColor('#98c800'),
        sipzeeGreen: createColor('#98c800'),
        sipzeeYellow: createColor('#ffb200'),
        sipzeeRed: createColor('#c02727'),
    },
});



function App() {
    const documentLoaded = useRef(false);
    const initialOptions = {
        "client-id": isTest() ? process.env.REACT_APP_PAYPAL_CLIENT_ID_TEST : process.env.REACT_APP_PAYPAL_CLIENT_ID_LIVE,
        currency: "USD",
        intent: "capture"
       
    };

    const [didLogin, setDidLogin] = useState(false);
    const [isValidating, setisValidating] = useState(false);
    const [validatedEmail, setValidatedEmail] = useState('');
    useEffect(() => {
       
        if (documentLoaded.current == false) {
            
            document.getElementsByTagName('body')[0].addEventListener('ReloginRequired', (event) => loginChanged());
            documentLoaded.current = true;

            let queryParams = new URLSearchParams(window.location.search);
            let authCode = queryParams.get("auth");
            let type = queryParams.get("type");

            if (authCode != null && type != null) {
                if (type == 'verify' && authCode.length > 15) {
                    console.log('authCode=' + authCode);
                    setisValidating(true);
                    validateNewSignup(authCode);
                }
            }
        }

    }, []);

    function validateNewSignup(authToken) {
      
        let postData = {
            token: authToken
        }

        TokenService.post(postData, 'Returner_ValidateNewAccount')
            .then((response) => {
               // response = response[Object.keys(response)[0]];
                if (response.Result == "SUCCESS") {
                    let jsonData = JSON.parse(response.JsonData);
                    setValidatedEmail(jsonData.Email);
                    setisValidating(false);
                }
            })
            .catch((response) => {
              
            });
    }

    function isTest() {
        if (window.location.href.indexOf('localhost') > -1) {
            return true;
        }
        else if (window.location.href.indexOf('test.sipzee.com') > -1) {
            return true;
        }
        else {
            return false;
        }
    }

    function getWebToken() {

        try {
          //  console.log('App: getWebToken');
            let webToken = JSON.parse(localStorage.getItem('Login')).WebToken;
            //console.log(webToken);
            if (webToken === '') {
                console.log('Web Token was empty');
                return null;
            }
            else {
                return webToken;
            }
          //  return JSON.parse(localStorage.getItem('Login')).WebToken; // persists after window close
        }
        catch (e) {
            console.log('error getting localStorage(Login)' + e);
        }

        console.log('getWebToken returning null');
        return null;
    }


    function loginChanged() {
       // console.log("loginChanged");
        setDidLogin(new Date())
    }

    function showLogin() {
       // console.log('showLogin');
        return (
            <div className="App" >
                <NavbarNoUser />
                <RecyclerLogin validatedEmail={validatedEmail} LoginChanged={() => loginChanged()} />
            </div>);
    }

    function showValidating() {
        return <div className="App">
            <Card sx={{ minWidth: 300, maxWidth: 400, alignSelf: 'center', margin: '10px', marginLeft: 'auto', marginRight: 'auto' }}>
                <CardContent>
                    <div >
                        <LoadingIndicator Message='Validating' /> 
                    </div>
                </CardContent>
            </Card>

        </div>
    }

    function showApp() {
       // console.log('showApp');
        return (<div className="App">
            <Navbar LoginChanged={() => loginChanged()} />
            <Routes>
                <Route path="/recycler" element={<Pickups />} />
                <Route path="/" element={<Pickups />} />
                <Route path="/Pickups" element={<Pickups />} />
                <Route path="/Index.html" element={<Pickups />} />
                <Route path="/MyAccount" element={<MyAccount />} />
                <Route path="/Training" element={<Training />} />
                <Route path="/BrandLookup" element={<BrandLookup />} />
                <Route path="/Marketing" element={<Marketing />} />
                <Route path="/ContactUs" element={<ContactUs />} />
                <Route path="/Store" element={<Store />} />
                <Route path="/#Admin" element={<Admin />} />
                <Route path="/Admin" element={<Admin />} />
                <Route path="/Pickup" component={() => {
                    window.location = '/Pickups';
                    return null;
                }} />
                <Route path="/Pickups" component={() => {
                    window.location = '/Pickups';
                    return null;
                }} />
               
                <Route path="/About" component={() => {
                    window.location = '/About';
                    return null;
                }} />
                <Route path="/Media" component={() => {
                    window.location = '/Media';
                    return null;
                }} />
                <Route path="/ContactUs" component={() => {
                    window.location = '/Contactus';
                    return null;
                }} />
                <Route path="/SignUp" component={() => {
                    window.location = '/SignUp';
                    return null;
                }} />
                
                <Route path="/Login" element={<Pickups />} />
            </Routes>
        </div>);
    }

    return (
        <ThemeProvider theme={theme}>
            <SnackbarProvider maxSnack={3} autoHideDuration={5000}>
                <PayPalScriptProvider options={initialOptions}>
                    {isValidating ?
                        showValidating()
                        :
                        getWebToken() === null ?
                            showLogin() : showApp()}
                </PayPalScriptProvider>
            </SnackbarProvider>
        </ThemeProvider>
    );
}

export default App;
